export interface TableFilters {
    [prop: string]: string|number|boolean;
}

export class TableFiltersSelection {
    private readonly _f: TableFilters;

    constructor(filters: TableFilters) {
        this._f = filters;
    }

    get filters(): TableFilters {
        return this._f ? this._f : {} as TableFilters;
    }

    add(filters: TableFilters): TableFiltersSelection {
        for (const key of Object.keys(filters)) {
            this._f[key] = filters[key];
        }

        return this;
    }

    remove(prop: string): TableFiltersSelection {
        if (Object.prototype.hasOwnProperty.call(this._f, prop)) {
            delete this._f[prop];
        }

        return this;
    }

    toggle(filters: TableFilters): TableFiltersSelection {
        for (const key of Object.keys(filters)) {
            if (this._f.hasOwnProperty(key)) {
                delete this._f[key];
            } else {
                this._f[key] = filters[key];
            }
        }

        return this;
    }
}
